import { useContext } from "react";
import { LoaderContext } from "../context/LoaderContext";
import TailoringContext from "../context/TailoringContext";
import {
  getLaundryTypes,
  laundryCheckout,
  makeLaundryOrder,
} from "../services/laundry";

const useLaundry = () => {
  const { setLoader } = useContext(TailoringContext);
  const {setErrMsg} = useContext(LoaderContext)

  const handleGetLaundryTypes = () => {
    return new Promise((resolve) => {
      getLaundryTypes()
        .then((res) => resolve(res))
        .catch((error) => console.log(error));
    });
  };
  const handleMakeLaundryOrder = (data) => {
    return new Promise((resolve) => {
      setLoader(true);

      makeLaundryOrder(data)
        .then((res) => {
          resolve(res);
          console.log(res?.data);
          setLoader(false);
        })
        .catch((error) => {
          console.log(error);
          setErrMsg(error.response.data.error)
          setLoader(false);
        });
    });
  };

  const handleLaundryCheckout = (id, data) => {
    return new Promise((resolve) => {
      setLoader(true);

      laundryCheckout(id, data)
        .then((res) => {
          resolve(res);
          console.log(res?.data);
          setLoader(false);
        })
        .catch((error) => {
          console.log(error);
          setLoader(false);
          setErrMsg(error.response.error)
        });
    });
  };

  return {
    handleMakeLaundryOrder,
    handleLaundryCheckout,
    handleGetLaundryTypes
  };
};

export default useLaundry;
